import styled from 'styled-components';
import {StyledCard as Card} from '../PrimaryCard/styles';
import {color} from 'styles/colors';

export const StyledCard:any=styled(Card)`
  	>p:last-child{
	  color: ${color.get('success-200')};
	}
`;